export enum RequestType {
  LOGIN = 'login',
  LOGOUT = 'logout',
  KEEPALIVE = 'keepalive'
}
